// const apiUrl = "http://localhost:3001"
const apiUrl = 
process.env.NODE_ENV === 'development' ? "http://localhost:3001" : "https://api.safd.top"

export default apiUrl